{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-720000",
  "sheetId": "NotesAccountingPolicies",
  "label": "[720000] Notes - Summary of Material Accounting Policies",
  "description": "Disclosure on summary of material accounting policies",
  "controls": [
    {
      "qname": "ifrs-full:DisclosureOfMaterialAccountingPolicyInformationExplanatory",
      "label": "Disclosure of material accounting policy information",
      "type": "TextBlock",
      "required": true,
      "ui": {
        "control": "richtext",
        "rows": 10,
        "note": "MANDATORY: Provide comprehensive disclosure of all material accounting policy information relevant to understanding the financial statements (IAS 1.117)"
      },
      "validators": [
        {
          "name": "required"
        }
      ],
      "error": {
        "required": "This is a mandatory field."
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForBiologicalAssetsExplanatory",
      "label": "Description of accounting policy for biological assets",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Accounting treatment for biological assets (MFRS 141)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForBorrowingCostsExplanatory",
      "label": "Description of accounting policy for borrowing costs",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Capitalization and recognition of borrowing costs (MFRS 123)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForBorrowingsExplanatory",
      "label": "Description of accounting policy for borrowings",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Recognition and measurement of borrowings"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForBusinessCombinationsExplanatory",
      "label": "Description of accounting policy for business combinations",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6,
        "note": "Acquisition method for business combinations (MFRS 3)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForCashFlowsExplanatory",
      "label": "Description of accounting policy for cash and cash equivalents",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 3,
        "note": "What is included in cash and cash equivalents"
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfAccountingPolicyForCommodityFutureAndForwardContractsExplanatory",
      "label": "Description of accounting policy for commodity future and forward contracts",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Treatment of commodity derivatives"
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfAccountingPolicyForConstructionContractExplanatory",
      "label": "Description of accounting policy for construction contracts",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Revenue recognition for construction contracts (MFRS 15)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForConstructionInProgressExplanatory",
      "label": "Description of accounting policy for construction in progress",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4,
        "note": "Measurement and recognition of construction in progress"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForContingentLiabilitiesAndContingentAssetsExplanatory",
      "label": "Description of accounting policy for contingent liabilities and contingent assets",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Recognition and disclosure of contingent items (MFRS 137)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForCustomerLoyaltyProgrammesExplanatory",
      "label": "Description of accounting policy for customer loyalty programmes",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4,
        "note": "Treatment of customer loyalty programs under MFRS 15"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForDecommissioningRestorationAndRehabilitationProvisionsExplanatory",
      "label": "Description of accounting policy for decommissioning, restoration and rehabilitation provisions",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Provisions for site restoration and decommissioning"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForDeferredIncomeTaxExplanatory",
      "label": "Description of accounting policy for deferred income tax",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6,
        "note": "Recognition and measurement of deferred tax (MFRS 112)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForDepreciationExpenseExplanatory",
      "label": "Description of accounting policy for depreciation expense",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6,
        "note": "Depreciation methods, useful lives, and residual values"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForDiscontinuedOperationsExplanatory",
      "label": "Description of accounting policy for discontinued operations",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4,
        "note": "Presentation and measurement of discontinued operations (MFRS 5)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForDividendsExplanatory",
      "label": "Description of accounting policy for dividend income",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 3,
        "note": "Recognition of dividend income"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForEarningsPerShareExplanatory",
      "label": "Description of accounting policy for earnings per share",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4,
        "note": "Calculation of basic and diluted EPS (MFRS 133)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForEmissionRightsExplanatory",
      "label": "Description of accounting policy for emission rights",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4,
        "note": "Treatment of emission rights and obligations"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForEmployeeBenefitsExplanatory",
      "label": "Description of accounting policy for employee benefits",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6,
        "note": "Short-term benefits, post-employment benefits, termination benefits (MFRS 119)"
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfAccountingPolicyForEquityInstrumentsExplanatory",
      "label": "Description of accounting policy for equity instruments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4,
        "note": "Recognition and measurement of equity instruments"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForExplorationAndEvaluationExpenditures",
      "label": "Description of accounting policy for exploration and development expenditures",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Capitalization and recognition of exploration costs (MFRS 6)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForFairValueMeasurementExplanatory",
      "label": "Description of accounting policy for fair value measurement",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Fair value hierarchy and measurement techniques (MFRS 13)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForFinanceIncomeAndCostsExplanatory",
      "label": "Description of accounting policy for finance income and costs",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4,
        "note": "Recognition of finance income and finance costs"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForFinancialGuaranteesExplanatory",
      "label": "Description of accounting policy for financial instruments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 7,
        "note": "Classification, recognition, measurement, impairment (MFRS 9)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForForeignCurrencyTranslationExplanatory",
      "label": "Description of accounting policy for foreign currencies",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6,
        "note": "Translation of foreign currency transactions and balances (MFRS 121)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForGoodwillExplanatory",
      "label": "Description of accounting policy for goodwill",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Initial measurement, subsequent measurement, impairment testing"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForGovernmentGrants",
      "label": "Description of accounting policy for government grants",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Recognition and presentation of government grants (MFRS 120)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForImpairmentOfFinancialAssetsExplanatory",
      "label": "Description of accounting policy for impairment of financial assets",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6,
        "note": "Expected credit loss model for financial assets (MFRS 9)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForImpairmentOfNonfinancialAssetsExplanatory",
      "label": "Description of accounting policy for impairment of other assets",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6,
        "note": "Impairment assessment and measurement for non-financial assets (MFRS 136)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForIncomeTaxExplanatory",
      "label": "Description of accounting policy for income tax",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 7,
        "note": "Current tax and deferred tax (MFRS 112)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForIntangibleAssetsOtherThanGoodwillExplanatory",
      "label": "Description of accounting policy for intangible assets other than goodwill",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6,
        "note": "Recognition, measurement, amortization (MFRS 138)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForInterestIncomeAndExpenseExplanatory",
      "label": "Description of accounting policy for interest income and expense",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4,
        "note": "Recognition using effective interest method"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForMeasuringInventories",
      "label": "Description of accounting policy for inventories",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Measurement basis, cost formula (FIFO, weighted average), net realizable value (MFRS 102)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForInvestmentInAssociates",
      "label": "Description of accounting policy for investment in associates",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Equity method or cost method (MFRS 128)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForInvestmentPropertyExplanatory",
      "label": "Description of accounting policy for investment property",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Cost model or fair value model (MFRS 140)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForInvestmentsInJointVentures",
      "label": "Description of accounting policy for investments in joint arrangements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Joint operations and joint ventures (MFRS 11)"
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfAccountingPolicyForInvestmentInSubsidiariesExplanatory",
      "label": "Description of accounting policy for investments in subsidiaries",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Cost method or other measurement basis (MFRS 10)"
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfAccountingPolicyForIrredemableCovertibleUnsecuredLoanStockExplanatory",
      "label": "Description of accounting policy for irredeemable convertible unsecured loan stocks (\"ICULS\")",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Treatment of ICULS as compound instruments"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForLeasesExplanatory",
      "label": "Description of accounting policy for leases",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 7,
        "note": "Right-of-use assets, lease liabilities, short-term leases, low-value assets (MFRS 16)"
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfAccountingPolicyForLossOfControlExplanatory",
      "label": "Description of accounting policy for loss of control",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4,
        "note": "Accounting for loss of control of subsidiaries (MFRS 10)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForNoncurrentAssetsOrDisposalGroupsClassifiedAsHeldForSaleExplanatory",
      "label": "Description of accounting policy for non-current assets or disposal groups classified as held for sale",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Classification and measurement of assets held for sale (MFRS 5)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForSegmentReportingExplanatory",
      "label": "Description of accounting policy for operating segment reporting",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Identification and measurement of operating segments (MFRS 8)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForProvisionsExplanatory",
      "label": "Description of accounting policy for other provisions",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Recognition criteria, measurement (MFRS 137)"
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfAccountingPolicyForPropertyDevelopmentCostsExplanatory",
      "label": "Description of accounting policy for property development costs",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Recognition and measurement of property development costs"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForPropertyPlantAndEquipmentExplanatory",
      "label": "Description of accounting policy for property, plant and equipment",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 8,
        "note": "Recognition, measurement, depreciation methods, useful lives (MFRS 116)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForRecognitionOfRevenue",
      "label": "Description of accounting policy for recognition of revenue and other income",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 8,
        "note": "Revenue recognition policies for different revenue streams (MFRS 15)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForResearchAndDevelopmentExpenseExplanatory",
      "label": "Description of accounting policy for research and development expense",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Treatment of research costs and development costs (MFRS 138)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForIssuedCapitalExplanatory",
      "label": "Description of accounting policy for share capital",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4,
        "note": "Accounting for ordinary shares, preference shares"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForSharebasedPaymentTransactionsExplanatory",
      "label": "Description of accounting policy for share-based payment transactions",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6,
        "note": "Equity-settled and cash-settled share-based payments (MFRS 2)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForTransactionsWithNoncontrollingInterestsExplanatory",
      "label": "Description of accounting policy for transactions with non-controlling interests",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Acquisitions and disposals of NCI without change in control (MFRS 10)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForTransactionsWithRelatedPartiesExplanatory",
      "label": "Description of accounting policy for transactions with related parties",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 5,
        "note": "Identification and disclosure of related party transactions (MFRS 124)"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForTreasurySharesExplanatory",
      "label": "Description of accounting policy for treasury shares",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4,
        "note": "Treatment of own shares repurchased and held by the entity"
      }
    },
    {
      "qname": "ifrs-full:DescriptionOfAccountingPolicyForWarrantsExplanatory",
      "label": "Description of accounting policy for warrants",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 4,
        "note": "Classification and measurement of warrants"
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfAccountingPolicyForOtherSignificantAccountingPoliciesRelevantToUnderstandingOfFinancialStatementsExplanatory",
      "label": "Description of other material accounting policies relevant to understanding of financial statements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6,
        "note": "Any other significant accounting policies not covered above"
      }
    }
  ]
}
